var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"text_box"},[_c('div',{staticClass:"text"},[_vm._v("网站维护中，敬请期待...")])])])}]

export { render, staticRenderFns }